import {useCallback} from "react";
import RouteConfigService from "../services/route-config.service";
import {CommonService} from "../services";
import {useLocation, useNavigate} from "react-router-dom";

type EntityType = "lab" | "facility" | "location";
type UserType = "Admin" | "User";

type CombinedType = `${EntityType}${UserType}`;

const useRedirectUser = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleRedirectUserModule = useCallback((props: { type: CombinedType }) => {
        const {type} = props;
        navigate(RouteConfigService.AddUserRoute() + CommonService.setUrlSearchParams({
            returnUrl: location.pathname + location.search,
            permissionType: type
        }))
    }, [location.pathname, location.search, navigate]);

    return {handleRedirectUserModule}
}

export default useRedirectUser;
